import { default as acceptInvitationConfiguration } from './acceptInvitation';
import { default as addAfslConfiguration } from './addAfsl';
import { default as addAfsLicenceConfiguration } from './addAfsLicence';
import { default as addIndustryRoleConfiguration } from './addIndustryRole';
import { default as addQualificationConfiguration } from './addQualification';
import { default as addUserBookmarkConfiguration } from './addUserBookmark';
import { default as approveQualificationConfiguration } from './approveQualification';
import { default as cancelSubscriptionConfiguration } from './cancelSubscription';
import { default as checkInvitationConfiguration } from './checkInvitation';
import { default as detachBusinessAdminConfiguration } from './detachBusinessAdmin';
import { default as getConfiguration } from './get';
import { default as getCpdCategoryConfiguration } from './getCpdCategory';
import { default as getCpdCategoryProgressConfiguration } from './getCpdCategoryProgress';
import { default as getCpdCategorysConfiguration } from './getCpdCategorys';
import { default as getCurrentConfiguration } from './getCurrent';
import { default as getDataFinishedConfiguration } from './getDataFinished';
import { default as getDataStartedConfiguration } from './getDataStarted';
import { default as getIndustryRolesConfiguration } from './getIndustryRoles';
import { default as getInvoicesConfiguration } from './getInvoices';
import { default as getProfileConfiguration } from './getProfile';
import { default as getQualificationsConfiguration } from './getQualifications';
import { default as getSnapshotReportConfiguration } from './getSnapshotReport';
import { default as getSubscriptionConfiguration } from './getSubscription';
import { default as getUserAfsLicencesConfiguration } from './getUserAfsLicences';
import { default as getUserBookmarksConfiguration } from './getUserBookmarks';
import { default as invitationSignUpConfiguration } from './invitationSignUp';
import { default as leaveTeamConfiguration } from './leaveTeam';
import { default as removeAfslConfiguration } from './removeAfsl';
import { default as removeQualificationConfiguration } from './removeQualification';
import { default as removeUserBookmarkConfiguration } from './removeUserBookmark';
import { default as sendInvitationsConfiguration } from './sendInvitations';
import { default as sendResetPasswordEmailConfiguration } from './sendResetPasswordEmail';
import { default as sendSupportRequestConfiguration } from './sendSupportRequest';
import { default as setCpdCategorysConfiguration } from './setCpdCategorys';
import { default as setIndustryRoleConfiguration } from './setIndustryRole';
import { default as setProgressGoalsConfiguration } from './setProgressGoals';
import { default as setTrainingPlanConfiguration } from './setTrainingPlan';
import { default as signUpConfiguration } from './signup';
import { default as subscribePlanConfiguration } from './subscribePlan';
import { default as updateConfiguration } from './update';
import { default as updateEmailConfiguration } from './updateEmail';
import { default as updateIndustryRoleConfiguration } from './updateIndustryRole';
import { default as updatePasswordConfiguration } from './updatePassword';
import { default as updatePaymentDetailsConfiguration } from './updatePaymentDetails';
import { default as updateQualificationConfiguration } from './updateQualification';
import { default as upgradeSubscriptionConfiguration } from './upgradeSubscription';

export const getDataConfigurations = [
  getDataFinishedConfiguration,
  getDataStartedConfiguration
]

export const configurations = [
  acceptInvitationConfiguration,
  addAfslConfiguration,
  addAfsLicenceConfiguration,
  addIndustryRoleConfiguration,
  addUserBookmarkConfiguration,
  cancelSubscriptionConfiguration,
  checkInvitationConfiguration,
  detachBusinessAdminConfiguration,
  getConfiguration,
  getCpdCategoryConfiguration,
  getCpdCategoryProgressConfiguration,
  getCpdCategorysConfiguration,
  getCurrentConfiguration,
  getIndustryRolesConfiguration,
  getSubscriptionConfiguration,
  getUserAfsLicencesConfiguration,
  getUserBookmarksConfiguration,
  invitationSignUpConfiguration,
  leaveTeamConfiguration,
  removeAfslConfiguration,
  sendInvitationsConfiguration,
  sendResetPasswordEmailConfiguration,
  setCpdCategorysConfiguration,
  setIndustryRoleConfiguration,
  setTrainingPlanConfiguration,
  signUpConfiguration,
  subscribePlanConfiguration,
  updateConfiguration,
  updateEmailConfiguration,
  updateIndustryRoleConfiguration,
  updatePasswordConfiguration,
  updatePaymentDetailsConfiguration,
  upgradeSubscriptionConfiguration,
  getQualificationsConfiguration,
  addQualificationConfiguration,
  updateQualificationConfiguration,
  removeQualificationConfiguration,
  removeUserBookmarkConfiguration,
  sendSupportRequestConfiguration,
  getInvoicesConfiguration,
  approveQualificationConfiguration,
  getProfileConfiguration,
  setProgressGoalsConfiguration,
  getSnapshotReportConfiguration
]

export const allConfigurations = [
  ...configurations,
  ...getDataConfigurations
]


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/index.js